import React from 'react';
import { motion } from 'framer-motion';
import { ChevronDownIcon, StarIcon } from 'lucide-react';
const BONO_1 = 'https://cdn.magicpatterns.com/uploads/2NRgcwdxWKzGcyNkZNazvM/NECESITO_UNA_IMAGEN_202604022304.png';
const BONO_2 = 'https://cdn.magicpatterns.com/uploads/itzibQJNGGXNCUcjgjyhDF/NECESITO_UNA_IMAGEN_202604022307.png';
const BONO_3 = 'https://cdn.magicpatterns.com/uploads/49fWrLyrvWBjs8zWugAhPW/BONO_3.png';
const BONO_4 = 'https://cdn.magicpatterns.com/uploads/fijhJ8wu8W3VARv7V3ojCw/BONO_4.png';
const BONO_5 = 'https://cdn.magicpatterns.com/uploads/xbVna7kSouhKtoYxT5M4kL/NECESITO_UNA_IMAGEN_202604022313.png';
const BONO_6 = 'https://cdn.magicpatterns.com/uploads/bpR3DR31vZcVbwinJRWhxn/BONO_6.png';
const BONO_7 = 'https://cdn.magicpatterns.com/uploads/auc4MBx7dgdC2Eq5jvn18i/BONO_7.png';
const BONO_8 = 'https://cdn.magicpatterns.com/uploads/gcHnmJvTmvojLMHJpzc8q5/BONO_8.png';
const BONO_PREMIUM = 'https://cdn.magicpatterns.com/uploads/76E4AhAqWow4Tt65LSQDku/BONO_PREMIUM.png';
const bonuses = [{
  id: 'bono-1',
  image: BONO_1,
  title: '1. Bebidas Frías para Cafetería',
  description: 'Opciones cremosas con matcha, café y taro. Recetas listas para servir en tu cafetería con ingredientes accesibles.',
  price: '$15.400 ARS',
  isPremium: false
}, {
  id: 'bono-2',
  image: BONO_2,
  title: '2. Bubble Tea Saludables',
  description: 'Alternativas naturales con miel, stevia y frutas frescas. Lo mejor en bubble tea saludable para tus clientes.',
  price: '$15.400 ARS',
  isPremium: false
}, {
  id: 'bono-3',
  image: BONO_3,
  title: '3. Bubble Tea Vegano',
  description: 'Recetas con leches vegetales y perlas sin gluten. Bubble tea vegano y sin gluten para ampliar tu carta.',
  price: '$17.600 ARS',
  isPremium: false
}, {
  id: 'bono-4',
  image: BONO_4,
  title: '4. Postres para Bubble Tea',
  description: 'Galletas y tartas para acompañar tu bubble tea. Postres temáticos que complementan tu carta de bebidas.',
  price: '$17.600 ARS',
  isPremium: false
}, {
  id: 'bono-5',
  image: BONO_5,
  title: '5. Perlas Explosivas',
  description: 'Descubre cómo preparar las famosas popping boba, perlas explosivas de sabores que sorprenderán a tus clientes.',
  price: '$18.200 ARS',
  isPremium: false
}, {
  id: 'bono-6',
  image: BONO_6,
  title: '6. 30 Sabores Extras de Perlas de Tapioca',
  description: 'Más allá de los sabores tradicionales de tu bubble tea. Añade un toque especial y sorprendente a tus bebidas con estas deliciosas y originales opciones como lichi, mango maracuya, kiwi, arandano, menta y muchos más.',
  price: '$15.400 ARS',
  isPremium: false
}, {
  id: 'bono-7',
  image: BONO_7,
  title: '7. Sodas Italianas',
  description: 'Aprende a preparar sodas frutales, cítricas y cremosas con ingredientes simples y presentaciones de impacto. ¡Refresca tu carta de bebidas con estas mezclas!',
  price: '$15.400 ARS',
  isPremium: false
}, {
  id: 'bono-8',
  image: BONO_8,
  title: '8. Plantilla de Costos',
  description: 'Sacale la rentabilidad a tus bebidas aquí te enseñamos como, desde los ingredientes hasta el vaso.',
  price: '$17.600 ARS',
  isPremium: false
}, {
  id: 'bono-premium',
  image: BONO_PREMIUM,
  title: 'Guía de Proveedores de Insumos de Bubble Tea y Repostería en América y España',
  description: 'Se detallan proveedores de ingredientes y suministros para bubble tea (tapioca, perlas, polvos, jarabes, vasos, etc.) y repostería, organizados por país.',
  price: '$18.200 ARS',
  isPremium: true
}];
export function BonusesSection() {
  return <section className="py-24 bg-[#FDFBF7] pt-[0px] pb-[0px]" data-id="element-14">
      <div className="max-w-6xl mx-auto px-4 sm:px-6 lg:px-8" data-id="element-15">
        <motion.div initial={{
        opacity: 0,
        y: 20
      }} whileInView={{
        opacity: 1,
        y: 0
      }} viewport={{
        once: true
      }} className="text-center mb-16 flex flex-col items-center" data-id="element-16">
          <h2 className="text-3xl md:text-5xl font-extrabold text-[#2D5A27] font-sans uppercase mb-6" data-id="element-17">
            ¡Y AÚN HAY MÁS!
          </h2>
          <p className="text-lg text-gray-600 max-w-2xl mx-auto mb-8 font-sans" data-id="element-18">
            Sabemos que también quieres innovar en el bubble tea ofreciendo
            nuevos sabores. Por eso te llevas totalmente{' '}
            <strong className="text-[#2D5A27] font-bold" data-id="element-19">GRATIS</strong> estos
            BONOS por hacer tu compra HOY:
          </p>
          <ChevronDownIcon className="w-10 h-10 text-[#2D5A27] animate-bounce" data-id="element-20" />
        </motion.div>

        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-6 md:gap-8" data-id="element-21">
          {bonuses.map((bono, index) => <motion.div key={bono.id} initial={{
          opacity: 0,
          y: 30
        }} whileInView={{
          opacity: 1,
          y: 0
        }} viewport={{
          once: true
        }} transition={{
          duration: 0.6,
          delay: index * 0.1
        }} className="h-full" data-id="element-22">
              {bono.isPremium /* Premium Card Wrapper */ ? <div className="h-full p-[3px] rounded-3xl bg-gradient-to-br from-[#D4A574] via-[#F5E6C8] to-[#D4A574] shadow-xl shadow-[#D4A574]/20" data-id="element-23">
                  <div className="flex flex-col h-full bg-gradient-to-b from-[#FFFBF0] to-white rounded-[21px] overflow-hidden relative" data-id="element-24">
                    {/* Premium Badge */}
                    <div className="absolute top-4 right-4 bg-gradient-to-r from-[#D4A574] to-[#8B6914] text-white text-xs font-bold px-4 py-1.5 rounded-full shadow-md z-10 flex items-center gap-1.5 uppercase tracking-wider" data-id="element-25">
                      <StarIcon className="w-3.5 h-3.5 fill-current" data-id="element-26" />
                      Premium
                    </div>

                    <div className="w-full aspect-[3/4] sm:aspect-[4/5] md:aspect-[3/4] overflow-hidden bg-white" data-id="element-27">
                      <img src={bono.image} alt={bono.title} className="w-full h-full object-contain p-4" data-id="element-28" />
                    </div>

                    <div className="p-8 flex flex-col flex-1 border-t border-[#D4A574]/20" data-id="element-29">
                      <h3 className="text-xl font-bold text-gray-900 mb-3 font-sans leading-tight" data-id="element-30">
                        <span className="block text-[#8B6914] text-sm uppercase tracking-wider mb-1" data-id="element-31">
                          Bono Premium:
                        </span>
                        {bono.title}
                      </h3>
                      <p className="text-gray-600 text-sm leading-relaxed mb-8 flex-1 font-sans" data-id="element-32">
                        {bono.description}
                      </p>

                      <div className="mt-auto pt-4 border-t border-gray-100 flex flex-col items-center text-center gap-1" data-id="element-33">
                        <p className="text-sm text-gray-500 font-medium" data-id="element-34">
                          Valor{' '}
                          <span className="line-through decoration-red-500/50" data-id="element-35">
                            {bono.price}
                          </span>
                        </p>
                        <p className="text-xl font-extrabold text-[#22C55E] uppercase tracking-wide" data-id="element-36">
                          ¡HOY INCLUIDO!
                        </p>
                      </div>
                    </div>
                  </div>
                </div> /* Standard Card */ : <div className="flex flex-col h-full bg-white rounded-3xl shadow-lg shadow-gray-200/50 overflow-hidden border border-gray-100" data-id="element-37">
                  <div className="w-full aspect-[3/4] sm:aspect-[4/5] md:aspect-[3/4] overflow-hidden bg-gray-50/50" data-id="element-38">
                    <img src={bono.image} alt={bono.title} className="w-full h-full object-contain p-4" data-id="element-39" />
                  </div>

                  <div className="p-8 flex flex-col flex-1 border-t border-gray-50" data-id="element-40">
                    <h3 className="text-xl font-bold text-gray-900 mb-3 font-sans leading-tight" data-id="element-41">
                      {bono.title}
                    </h3>
                    <p className="text-gray-500 text-sm leading-relaxed mb-8 flex-1 font-sans" data-id="element-42">
                      {bono.description}
                    </p>

                    <div className="mt-auto pt-4 border-t border-gray-100 flex flex-col items-center text-center gap-1" data-id="element-43">
                      <p className="text-sm text-gray-500 font-medium" data-id="element-44">
                        Valor{' '}
                        <span className="line-through decoration-red-500/50" data-id="element-45">
                          {bono.price}
                        </span>
                      </p>
                      <p className="text-xl font-extrabold text-[#22C55E] uppercase tracking-wide" data-id="element-46">
                        ¡HOY INCLUIDO!
                      </p>
                    </div>
                  </div>
                </div>}
            </motion.div>)}
        </div>
      </div>
    </section>;
}